import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(
    createAction<{ email: string; code: string; newPassword: string }>(
        'auth/SUBMIT_FORGOT_PASSWORD',
    ),
);
